var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.028 4.853a.394.394 0 00.082.42l4.507 4.614a.37.37 0 00.532 0 .39.39 0 000-.544L1.282 5.385h8.109A.38.38 0 009.766 5a.38.38 0 00-.375-.385H1.282L5.149.657a.39.39 0 000-.544.37.37 0 00-.532 0L.11 4.728a.388.388 0 00-.082.125z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default __webpack_public_path__ + "static/media/arrow.64852e3f.svg";
export { SvgArrow as ReactComponent };